import { createHandoff } from '../../utils/handoff';

// An admin invite prepared elsewhere (a Laila card) for the Add Admin dialog
// to open with, on its roles step.
export interface AdminInvitePrefill {
  email: string;
  position: string;
  // A role per module; resourceIds are the teams, sites or pay schedules a
  // scoped role covers.
  roles: { roleId: string; resourceIds: string[] }[];
}

export const adminInvitePrefill = createHandoff<AdminInvitePrefill>();
